export const dsn = 'https://910e1d503d7e4ce6b32270616c47ff1c@sentry.io/1796934';
